webpackJsonp([27],{

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(18);

var _storyblokReact = __webpack_require__(31);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

var _reactStatic = __webpack_require__(12);

__webpack_require__(489);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Third Party
function AboutTheAuthor(_ref) {
  var content = _ref.story.content;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'title',
        null,
        content && content.top[0].title
      )
    ),
    content && content.top.map(function (el) {
      return _react2.default.createElement(
        _storyblokReact2.default,
        { key: el._uid, content: el },
        _react2.default.createElement(
          'div',
          {
            className: 'hero hero--small',
            style: {
              backgroundImage: 'url(' + el.image + ')',
              backgroundPosition: 'center ' + (el.image_offset ? el.image_offset + '%' : '50%')
            }
          },
          _react2.default.createElement('div', { className: 'hero__overlay' }),
          _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(
              'h1',
              { className: 'hero__title hero--small__title' },
              el.title
            )
          )
        )
      );
    }),
    _react2.default.createElement(
      'div',
      { className: 'DescContainer bg-dark' },
      _react2.default.createElement(
        'div',
        { className: 'leftTextContainer' },
        content && content.testimonials.map(function (el) {
          if (el.component === 'Section Title') {
            return _react2.default.createElement(
              _storyblokReact2.default,
              { key: el._uid, content: el },
              _react2.default.createElement(
                'h2',
                { className: 'sectionTitleTest' },
                el.text
              )
            );
          }
          if (el.component === 'Page Subtitle') {
            return _react2.default.createElement(
              _storyblokReact2.default,
              { key: el._uid, content: el },
              _react2.default.createElement(
                'p',
                { className: 'PageSubtitleTest' },
                el.text
              )
            );
          }
          if (el.component === 'Paragraph') {
            return _react2.default.createElement(
              _storyblokReact2.default,
              { key: el._uid, content: el },
              _react2.default.createElement(
                'p',
                { className: 'ParagraphTitleTest' },
                el.text
              )
            );
          }
          if (el.component === 'Hero') {
            return _react2.default.createElement(
              _storyblokReact2.default,
              { key: el._uid, content: el },
              _react2.default.createElement('div', { className: 'bgImg', style: { backgroundImage: 'url(' + el.image + ')' } })
            );
          }
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'imgPart' },
        content && content.testimonials.map(function (el) {
          if (el.component === 'Image') {
            return _react2.default.createElement(
              _storyblokReact2.default,
              { key: el._uid, content: el },
              _react2.default.createElement('img', { className: 'introPersonImgBook', src: el.file, alt: 'navigation item' })
            );
          }
        }),
        _react2.default.createElement(
          'div',
          { className: 'socialList' },
          content && content.testimonials.map(function (el) {
            if (el.component === 'Social Link') {
              return _react2.default.createElement(
                _storyblokReact2.default,
                { key: el._uid, content: el },
                _react2.default.createElement(
                  'a',
                  { href: el.link, target: '_blank', rel: 'noopener noreferrer' },
                  _react2.default.createElement('img', { className: 'socialLink', src: el.icon, alt: 'socialLink' })
                )
              );
            }
          })
        )
      )
    )
  );
}

// Project
exports.default = (0, _reactStatic.withRouteData)(AboutTheAuthor);

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/AboutTheAuthor.5d4d45cd.js